import { Amplify, Auth } from 'aws-amplify';
import { ENV_VARIABLES, ENV } from 'constants/env';

Amplify.configure(ENV_VARIABLES[ENV].AWS_CONFIG);

// You can get the current config object
export const currentAwsConfig = Auth.configure();
